const isDev = process.env.NODE_ENV === 'development'
export default [
  {
    key: 'basic_plan',
    tier: 'Basic',
    description: 'For teams of all sizes saving & organizing ad inspiration.',
    price: {
      monthly: 59,
      annual: 49
    },
    baseQuantity: 1,
    annualSavings: 120,
    marketAnnual: 599,
    priceId: {
      monthly: isDev ? 'price_1RLrttAQtq0TW7KZZXUFVcuR' : 'price_1RPEMoAQtq0TW7KZDYBYE0oG',
      annual: isDev ? 'price_1RLruxAQtq0TW7KZAH4QP9ZM' : 'price_1RMEMsAQtq0TW7KZSDalZ3dH'
    }
  },
  {
    key: 'workflow_plan',
    tier: 'Workflow',
    description: 'The complete winning ad workflow for scaling teams.',
    isPopular: true,
    baseQuantity: 5,
    price: {
      monthly: 175,
      annual: 149
    },
    annualSavings: 310,
    marketAnnual: 1800,
    priceId: {
      monthly: isDev ? 'price_1RLrqCAQtq0TW7KZIU5T0Xc4' : 'price_1RMELcAQtq0TW7KZEgwOHpVQ',
      annual: isDev ? 'price_1RLrsXAQtq0TW7KZse4iZeOD' : 'price_1RMELgAQtq0TW7KZw98seOJy'
    },
    addOns: {
      lens: {
        monthly: { priceId: isDev ? 'price_1RMCDWAQtq0TW7KZm0S41GTK' : 'price_1RMEM4AQtq0TW7KZ0homnuxU', quantity: 1 },
        annual: { priceId: isDev ? 'price_1RMCDyAQtq0TW7KZC9xAvvhd' : 'price_1RiyauAQtq0TW7KZM2Fa9vZl', quantity: 1 }
      },
      spyder: {
        monthly: { priceId: isDev ? 'price_1RLrdWAQtq0TW7KZHOm4TYN8' : 'price_1RMEDUAQtq0TW7KZudgiOTA4', quantity: 10 },
        annual: { priceId: isDev ? 'price_1RLrY7AQtq0TW7KZsBO2rDw4' : 'price_1RMEDSAQtq0TW7KZPC6SVzF4', quantity: 999 }
      }
    }
  },
  {
    key: 'agency_plan',
    tier: 'Agency',
    description: 'Supercharging marketing groups to scale multiple ad accounts.',
    baseQuantity: 10,
    price: {
      monthly: 459,
      annual: 389
    },
    annualSavings: 820,
    marketAnnual: 4700,
    priceId: {
      monthly: isDev ? 'price_1RM9wfAQtq0TW7KZYvcvcvwu' : 'price_1RPEL0AQtq0TW7KZRHIntE4x',
      annual: isDev ? 'price_1RLsqMAQtq0TW7KZFlUHbFAf' : 'price_1RMDweAQtq0TW7KZuOKRIR6Z'
    },
    addOns: {
      lens: {
        monthly: { priceId: isDev ? 'price_1RMByYAQtq0TW7KZwkAtFuCn' : 'price_1RPAVaAQtq0TW7KZxMznyOl2', quantity: 10 },
        annual: { priceId: isDev ? 'price_1RLnrcAQtq0TW7KZykH6gJmL' : 'price_1SVewrAQtq0TW7KZLtqVykZ5', quantity: 10 }
      },
      spyder: {
        monthly: { priceId: isDev ? 'price_1RLrdWAQtq0TW7KZHOm4TYN8' : 'price_1RMEDUAQtq0TW7KZudgiOTA4', quantity: 25 },
        annual: { priceId: isDev ? 'price_1RLrY7AQtq0TW7KZsBO2rDw4' : 'price_1RMEDSAQtq0TW7KZPC6SVzF4', quantity: 999 }
      }
    }
  }
]
